/**
 * Amazon Deal Page - Sticky Footer Controller
 * Handles the display and hiding of the sticky footer based on scroll position
 */

class AmazonStickyFooter {
  constructor() {
    this.stickyFooter = document.getElementById('amazonStickyFooter');
    this.heroSection = document.querySelector('.amazon-hero');
    this.footerSection = document.querySelector('.shopify-section-group-footer-group, footer');
    this.isVisible = false;
    this.lastScrollY = 0;
    this.throttleTimer = null;
    
    this.init();
  }

  init() {
    if (!this.stickyFooter) return;
    
    this.bindEvents();
    this.checkInitialPosition();
  }

  bindEvents() {
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
  }

  handleScroll() {
    if (this.throttleTimer) return;
    
    this.throttleTimer = setTimeout(() => {
      this.updateFooterVisibility();
      this.throttleTimer = null;
    }, 16); // ~60fps
  }

  handleResize() {
    this.updateFooterVisibility();
  }

  updateFooterVisibility() {
    const scrollY = window.scrollY;
    const shouldShow = this.shouldShowFooter();
    
    if (shouldShow && !this.isVisible) {
      this.showFooter();
    } else if (!shouldShow && this.isVisible) {
      this.hideFooter();
    }
    
    this.lastScrollY = scrollY;
  }

  shouldShowFooter() {
    const scrollY = window.scrollY;
    
    // Don't show if we haven't scrolled past the hero section
    if (this.heroSection) {
      const heroBottom = this.heroSection.offsetTop + this.heroSection.offsetHeight;
      if (scrollY <= heroBottom - window.innerHeight * 0.3) {
        return false;
      }
    }
    
    // Hide when footer comes into view
    if (this.footerSection) {
      const footerTop = this.footerSection.offsetTop;
      const viewportBottom = scrollY + window.innerHeight;
      
      if (viewportBottom >= footerTop - 50) {
        return false;
      }
    }
    
    return true;
  }

  showFooter() {
    if (!this.stickyFooter) return;
    
    this.isVisible = true;
    this.stickyFooter.classList.remove('hidden', 'slide-down');
    this.stickyFooter.classList.add('visible', 'slide-up');
  }

  hideFooter() {
    if (!this.stickyFooter) return;
    
    this.isVisible = false;
    this.stickyFooter.classList.remove('visible', 'slide-up');
    this.stickyFooter.classList.add('hidden', 'slide-down');
  }

  checkInitialPosition() {
    // Check initial scroll position on page load
    setTimeout(() => {
      this.updateFooterVisibility();
    }, 100);
  }

  // Public method to manually trigger visibility check
  refresh() {
    this.updateFooterVisibility();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.amazonStickyFooter = new AmazonStickyFooter();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.amazonStickyFooter = new AmazonStickyFooter();
  });
} else {
  window.amazonStickyFooter = new AmazonStickyFooter();
}

// Fallback initialization for immediate execution
(() => {
  if (typeof window.amazonStickyFooter === 'undefined') {
    window.amazonStickyFooter = new AmazonStickyFooter();
  }
})();


